// tanstack
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

// shared components
import { ServiceGuard } from '@/components/access-control/ServiceGuard';
import PageContainer from '@/components/layout/PageContainer';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute(
  '/$accountId/_user/predictive-heat-control',
)({
  component: () => (
    <ServiceGuard
      serviceNames={['PVO']}
      fallback={<Navigate to="/$accountId" />}
    >
      <PageContainer maxWidth="xl" sx={{ py: 2 }}>
        <Outlet />
      </PageContainer>
    </ServiceGuard>
  ),
  errorComponent: ErrorBoundary,
  staticData: {
    crumb: 'buildingOptimization:predictiveHeatControlSavingsDashboard.title',
  },
});
